<template minapp='mpx' xlang='wxml'>
  <view class="es-calendar">
    <view class="es-calendar__header">
      <view class="es-calendar__title dawn-title"
        >{{ title }}
        <text wx:if="{{showTip}}" class="title-des">(入离时间均为酒店当地日期)</text>
      </view>
      <popover wx:if="{{show}}" text="{{isDawn ? dawnTip : ''}}" />
      <es-week firstDay="{{firstDay}}"></es-week>
    </view>
    <scroll-view scroll-y class="es-calendar__body" scroll-into-view="{{scrollview}}">
      <es-month
        wx:for="{{ months }}"
        wx:key="*this"
        firstDay="{{firstDay}}"
        id="month{{index}}"
        type="{{type}}"
        color="{{color}}"
        date="{{item}}"
        minDate="{{minDate}}"
        maxDate="{{maxDate}}"
        startText="{{startText}}"
        endText="{{endText}}"
        currentDate="{{currentDate}}"
        isDawn="{{isDawn}}"
        timeZoneDate="{{timeZoneDate}}"
        showPop="{{showPop&&showTip}}"
        calendarHoliday="{{calendarHoliday}}"
        bind:click="onSelected"
        bind:invalid="onInvalid"
      ></es-month>
    </scroll-view>

    <view class="es-calendar__footer" wx:if="{{showConfirm && type !== 'single'}}">
      <view class="es-calendar__info es-calendar__info__line" wx:if="{{type === 'range'}}">
        <view class="es-calendar__info__item" wx:if="{{shortText.from}}">
          <view class="es-calendar__info__item__line">
            <view
              class="es-calendar__info__item__dawn__sun"
              wx:if="{{shortText.from.isDawn}}"
            ></view>
            <view class="es-calendar__info__item__dawn" wx:if="{{shortText.from.isDawn}}">
              {{ shortText.from.isDawn }}
            </view>
            <view class="es-calendar__info__item__name">
              {{ shortText.from.name }}
            </view>
          </view>
          <view class="es-calendar__info__item__line">
            <view class="es-calendar__info__item__value">
              {{ shortText.from.value }}
            </view>
            <view class="es-calendar__info__item__des">
              {{ shortText.from.des }}
            </view>
          </view>
        </view>
        <view class="es-calendar__info__during">
          <view class="line"></view>
        </view>
        <view class="es-calendar__info__item">
          <view class="es-calendar__info__item__line">
            <view
              class="es-calendar__info__item__dawn__moon"
              wx:if="{{shortText.to.isDawn}}"
            ></view>
            <view class="es-calendar__info__item__dawn" wx:if="{{shortText.to.isDawn}}">
              {{ shortText.to.isDawn }}
            </view>
            <view class="es-calendar__info__item__name">
              {{ shortText.to.name }}
            </view>
          </view>
          <view class="es-calendar__info__item__line">
            <view
              class="{{ shortText.to.des ? 'es-calendar__info__item__value' : 'es-calendar__info__item__no__date'}}"
            >
              {{ shortText.to.value }}
            </view>
            <view class="es-calendar__info__item__des">
              {{ shortText.to.des }}
            </view>
          </view>
        </view>
      </view>
      <view
        wx:if="{{showConfirm && type !== 'single'}}"
        class="{{forbidden?'btn-disabled':'btn-confirm'}}"
        bindtap="onConfirm"
      >
        {{ confirmText }}
      </view>
    </view>
  </view>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import {
    compare,
    getDayByOffset,
    getToday,
    getPrevDay,
    getNextDay,
    calcDateNum,
    isFunction,
    getFullDate,
    formatDate,
    isToday
  } from '@didi/es-mpx-shared'
  /**
   * @description 获取日历节假日数据
   */
  export const getHolidayData = (params) => mpx.$http.get('/esapp/category/info/holidays', { params })

  createComponent({
    // pageLifetimes: {
    //   show: function () {
    //     this.$forceUpdate()
    //   },
    // },
    props: {
      disabled: {
        type: Boolean,
        value: false
      },
      // 默认值 timestamp | timestamp[]
      value: {
        type: Array,
        optionalTypes: [Number, String]
      },
      // 日历类型 range|single|multiple
      type: {
        type: String,
        value: 'single'
      },
      // 标题
      title: {
        type: String,
        value: '请选择日期'
      },
      // 自定义时间格式化
      formatter: null,
      // 选中底色
      color: {
        type: String,
        value: '#1473FF'
      },
      // 是否显示底部确定按钮
      showConfirm: {
        type: Boolean,
        value: true
      },

      startText: {
        type: String,
        value: '入住'
      },

      endText: {
        type: String,
        value: '离店'
      },
      // 底部按钮文案
      confirmText: {
        type: String,
        value: '确认'
      },
      // 起始周
      firstDay: {
        type: Number,
        value: 0
      },
      // 可选择最小时间
      minDate: {
        type: null,
        value: Date.now()
      },
      // 可选择最大时间
      maxDate: {
        type: null,
        value: Date.now()
      },
      format: null,
      // 多选最多可以选几个
      maxRange: Number,
      allowSameDay: Boolean,
      invalidText: String,
      isDawn: {
        type: Boolean,
        value: false
      },
      showTip: {
        type: Boolean,
        value: false
      },
      timeZoneDate: {
        type: String,
        value: null
      }
    },

    data: {
      currentDate: [], // date|date[]
      currentHour: null,
      showPop: false,
      dawnTip: '如需今天凌晨6点前入住，请选"今天凌晨"入住',
      calendarHoliday: []
    },

    watch: {
      value(val) {
        this.$nextTick(() => {
          this.currentDate = Array.isArray(val) ? val.slice() : [val]
        })
      }
    },

    computed: {
      shortText() {
        let [start, end] = this.currentDate
        const result = {}
        if (start) {
          const startDate = getFullDate(start)
          result.from = {
            name: this.startText,
            value: startDate.month + '月' + startDate.day + '日',
            des:
              this.timeZoneDate != null
                ? new Date(this.timeZoneDate).getTime() === start
                  ? '今天'
                  : '周' + startDate.weekName
                : getToday().getTime() === start
                ? '今天'
                : '周' + startDate.weekName
          }
          if (this.timeZoneDate != null) {
            this.isDawn && getNextDay(start).getTime() === new Date(this.timeZoneDate).getTime()
              ? (result.from.isDawn = '凌晨')
              : ''
          } else {
            this.isDawn && getNextDay(start).getTime() === getToday().getTime()
              ? (result.from.isDawn = '凌晨')
              : ''
          }
        }
        if (end) {
          const endDate = getFullDate(end)
          result.to = {
            name: this.endText,
            value: endDate.month + '月' + endDate.day + '日',
            des: '周' + endDate.weekName
          }
          if (this.timeZoneDate != null) {
            this.isDawn && new Date(this.timeZoneDate).getTime() === end
              ? (result.to.isDawn = '中午')
              : ''
          } else {
            this.isDawn && getToday().getTime() === end ? (result.to.isDawn = '中午') : ''
          }
        } else {
          result.to = {
            name: this.endText,
            value: this.showTip ? '请选择离店日期' : this.endText
          }
        }
        return result
      },
      scrollview() {
        const [minDate] = Array.isArray(this.value) ? this.value : [this.value]
        if (minDate) {
          const date = new Date(typeof minDate === 'string' ? minDate.replace(/-/g, '/') : minDate)
          date.setDate(1)
          date.setHours(0, 0, 0, 0)
          const index = this.months.indexOf(date.getTime())
          if (index > -1) {
            return `month${index}`
          }
        }
        return 'month0'
      },
      forbidden() {
        const { currentDate, type } = this
        if (currentDate == null) {
          return true
        }

        if (type === 'range') {
          return !currentDate[0] || !currentDate[1]
        }

        if (type === 'multiple') {
          return !currentDate.length
        }

        return !currentDate
      },
      months() {
        const times = []
        const { minDate, maxDate } = this
        const start = new Date(minDate)
        const end = new Date(maxDate)
        const endTime = end.getTime()
        end.setHours(0, 0, 0, 0)

        while (start.getTime() <= endTime) {
          start.setHours(0, 0, 0, 0)
          times.push(start.getTime())
          start.setDate(1)
          start.setMonth(start.getMonth() + 1)
        }
        return times
      },
      show() {
        return this.showTip && this.isDawn
      }
    },

    methods: {
      toast(title) {
        mpx.showToast({
          title,
          icon: 'none'
        })
      },
      onInvalid(event) {
        if (this.invalidText) {
          this.toast(this.invalidText)
        }
      },
      onSelected(event) {
        const { type, currentDate, disabled } = this
        const { detail } = event
        const { date } = detail

        if (disabled) {
          return
        }

        if (type === 'range') {
          const [startDay, endDay] = currentDate

          if (startDay && !endDay) {
            const compareToStart = compare(date, startDay)

            if (compareToStart === 1) {
              this.select([startDay, date], true)
            } else if (compareToStart === -1) {
              this.select([date, null])
            } else {
              if (this.allowSameDay) {
                this.select([date, date])
              } else {
                this.select([date, null])
              }
            }
          } else {
            this.select([date, null])
          }
        } else if (type === 'multiple') {
          let selectedIndex
          const selected = currentDate.some((dateItem, index) => {
            const equal = compare(dateItem, date) === 0
            if (equal) {
              selectedIndex = index
            }
            return equal
          })

          if (selected) {
            const cancelDate = currentDate.splice(selectedIndex, 1)
            this.select(currentDate)
          } else {
            this.select([...currentDate, date])
          }
        } else {
          this.select([date], true)
        }
      },

      getInitialDate(defaultDate) {
        const { type, minDate, maxDate } = this

        const now = getToday().getTime()
        if (type === 'range') {
          const [startDay, endDay] = defaultDate || []

          const start = this.limitDateRange(startDay || now, minDate, getPrevDay(maxDate).getTime())
          const end = this.limitDateRange(endDay || now, maxDate, getNextDay(minDate).getTime())
          return [start, end]
        }

        if (type === 'multiple') {
          if (Array.isArray(defaultDate)) {
            return defaultDate.map((date) => this.limitDateRange(date))
          }

          return [this.limitDateRange(now)]
        }

        if (!defaultDate || Array.isArray(defaultDate)) {
          defaultDate = now
        }
        return [this.limitDateRange(defaultDate)]
      },

      limitDateRange(date, minDate, maxDate) {
        minDate = minDate || this.minDate
        maxDate = maxDate || this.maxDate
        if (compare(date, minDate) === -1) {
          return minDate
        }
        if (compare(date, maxDate) === 1) {
          return maxDate
        }
        return date
      },

      select(date, complete) {
        if (complete && this.type === 'range') {
          const valid = this.checkRange(date)
          this.showPop = valid
          if (this.showPop) {
            setTimeout(() => {
              this.showPop = false
            }, 5000)
          }

          if (!valid) {
            if (this.showConfirm) {
              this.emit([date[0], getDayByOffset(date[0], this.maxRange - 1)])
            } else {
              this.emit(date)
            }
            return
          }
        }

        this.emit(date)

        if (complete && !this.showConfirm) {
          this.onConfirm()
        }
      },

      emit(date) {
        const getTime = (date) => (date instanceof Date ? date.getTime() : date)

        ;(this.currentDate = Array.isArray(date) ? date.map(getTime) : [getTime(date)]),
          this.$trigger('input', {
            value: this.type === 'single' ? this.currentDate[0] : this.currentDate.slice()
          })
      },

      checkRange(date) {
        const { maxRange } = this
        const limitDate = calcDateNum(date[0], date[1])
        if (maxRange && limitDate > maxRange) {
          this.toast(`选择天数不能超过 ${maxRange} 天`)
          this.$trigger('input', {
            value: date.slice()
          })
          return false
        }
        return true
      },

      onConfirm() {
        if (this.type === 'range' && !this.checkRange(this.currentDate)) {
          return
        }

        this.$nextTick(() => {
          if (!this.forbidden) {
            this.$trigger('confirm', this.currentDate)
          }
        })
      },
      /**
       * @description: 获取日历节假日数据
       */
      async getHoliday(params = {}) {
        if (this.calendarHoliday.length) return
        try {
          const res = await getHolidayData(params)
          const { date_list } = res?.data || {}
          this.calendarHoliday = date_list ? date_list : []
        } catch (error) {
          console.log(error)
        }
      }
    },

    created() {
      this.currentDate = this.value || this.getInitialDate()
      this.currentHour = getFullDate(new Date().getTime()).hour
      this.getHoliday()
    }
  })
</script>

<style lang='stylus' src='./style.styl' scoped></style>
<script  type='application/json' lang='json'>
{
 "component": true,
 "usingComponents": {
    "es-week": "./week",
    "es-month": "./month",
    "popover": './popover',
    "es-button": '../button/index',
    "es-toast": '../toast/index',
 }
}
</script>

